/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eta_Window_Set_SuccessInputs */

const en_eta_window_set_success = /** @type {(inputs: Eta_Window_Set_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETA window sent.`)
};

const ja_eta_window_set_success = /** @type {(inputs: Eta_Window_Set_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`到着予定時間帯を送信しました。`)
};

const fr_eta_window_set_success = /** @type {(inputs: Eta_Window_Set_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créneau d'arrivée envoyé.`)
};

const de_eta_window_set_success = /** @type {(inputs: Eta_Window_Set_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETA-Zeitfenster gesendet.`)
};

/**
* | output |
* | --- |
* | "ETA window sent." |
*
* @param {Eta_Window_Set_SuccessInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const eta_window_set_success = /** @type {((inputs?: Eta_Window_Set_SuccessInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eta_Window_Set_SuccessInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eta_window_set_success(inputs)
	if (locale === "ja") return ja_eta_window_set_success(inputs)
	if (locale === "fr") return fr_eta_window_set_success(inputs)
	return de_eta_window_set_success(inputs)
});